import { EDITOR_TYPES, Editors, RobotProblem } from '../robot.types';

export function getEditor(markup: RobotProblem['markup']): Editors {
    // грязный хак, символ § в начале инструкции включает light редактор
    const forceLightEditor = markup.options.instruction[0] === '§';

    // старая разметка без code_editors
    if (!markup.code_editors?.length) {
        if (forceLightEditor) {
            return {
                editor: EDITOR_TYPES.LIGHT_PYTHON,
                author_solution: { code: markup.author_solution || '' },
                author_solution_run: markup.author_solution_run,
            };
        }

        return {
            editor: EDITOR_TYPES.PYTHON,
            author_solution: { code: markup.author_solution || '' },
            author_solution_run: markup.author_solution_run,
        };
    }

    const codeEditor = markup.code_editors[0];

    if (forceLightEditor) {
        return {
            editor: EDITOR_TYPES.LIGHT_PYTHON,
            author_solution: { code: codeEditor.author_solution.code },
            author_solution_run: codeEditor.author_solution_run,
        };
    }

    return codeEditor;
}

export function getIsLightEditor(problem: RobotProblem) {
    const editor = getEditor(problem.markup);
    return editor?.editor === EDITOR_TYPES.LIGHT_PYTHON;
}

export function prepareInstruction(i: string): string {
    return i.replace(/^§\s*/, '');
}
